import { apiUrl } from "./api";

/**
 * The platform's guide, as the admin and the portal read it (19.10.2026).
 * The server decides who sees what (`services/guide/viewers.py`); this only
 * words and arranges it.
 */

/** "/api/admin/guide/img/x.webp" → the API's host, wherever the site runs. */
export function imageSrc(src) {
  if (!src) return "";
  return /^https?:\/\//.test(src) ? src : apiUrl(String(src).replace(/^\/?api\//, ""));
}

/** The article an address asks for: `?a=grupe/crearea`. */
export const ARTICLE_PARAM = "a";

/** The articles that explain a page, for its (?): those whose `screen` is that page. */
export function articlesForScreen(index, screen) {
  const out = [];
  for (const c of index?.chapters || []) {
    for (const a of c.articles || []) if (a.screen === screen) out.push(a);
  }
  return out.sort((x, y) => (x.order ?? 100) - (y.order ?? 100));
}

/** "Ce e nou" since the reader last opened the guide: a dot on the tab while there is any. */
export function unseenNews(index, lastSeen) {
  const since = lastSeen ? String(lastSeen).slice(0, 10) : "";
  return (index?.news || []).filter((n) => n.updated && (!since || n.updated > since));
}

export const LAST_SEEN_KEY = "fped_guide_last_seen";

export function readLastSeen(storage = typeof window !== "undefined" ? window.localStorage : null) {
  try { return storage?.getItem(LAST_SEEN_KEY) || ""; } catch { return ""; }
}

export function markSeen(today, storage = typeof window !== "undefined" ? window.localStorage : null) {
  try { storage?.setItem(LAST_SEEN_KEY, today); } catch { /* a private window: the dot simply stays */ }
}

/** Today in Bucharest, "2026-10-19": what "seen" is stamped with. */
export function today(now = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Bucharest" }).format(now);
}

/** "19 octombrie 2026". */
export function longDay(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("ro-RO", { day: "numeric", month: "long", year: "numeric", timeZone: "Europe/Bucharest" })
    .format(new Date(`${iso}T12:00:00Z`));
}

/** The ticket prefilled from "Lipsește ceva sau e greșit?". */
export function reportPrefill(article) {
  return {
    area: "ghid",
    kind: "improvement",
    title: article?.title ? `Ghid: ${article.title}` : "Ghid: lipsește un articol",
    description: article?.id ? `Articolul: ${article.title} (${article.id})\n\nCe lipsește sau e greșit: ` : "Ce căutam: ",
  };
}
